import { useState, useCallback } from 'react';
import { getServiceNumbers, putServiceNumbers } from '../services/numbers';

const useNumbers = () => {
  const [state, setState] = useState({ loading: false, error: null, states: [] });

  const getNumbers = useCallback(async (data) => {
    setState({ loading: true, error: null, roles: [] });
    try {
      const states = await getServiceNumbers(data);
      setState({ loading: false, error: null, states });
      return states;
    } catch (e) {
      setState({ loading: false, error: e, roles: [] });
      return [];
    }
  });

  const editNumbers = useCallback(async (data) => {
    setState({ loading: true, error: null });
    try {
      const { id, consecutive } = data;
      await putServiceNumbers({ id, consecutive });
      setState({ loading: false, error: null });
      return true;
    } catch (e) {
      setState({ loading: false, error: e });
      return false;
    }
  });

  return {
    isStateLoading: state.loading,
    statesError: state.error,
    getNumbers,
    editNumbers,
  };
};

export default useNumbers;
